// Json-ld schema for SEO
// Implementation: https://blog.haroen.me/json-ld-with-react

const ratingData = {
  '@context': 'http://schema.org',
  '@type': 'Service',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    bestRating: '5',
  },
};

const helpData = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  url: 'https://hubblehq.com',
  email: 'mailto:help@hubblehq.com',
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+44-203-608-0215',
      contactType: 'customer service',
    },
  ],
};

export { helpData, ratingData };
export default { helpData, ratingData };
